<div class="berry-container flex h-100">
    <div class="flex-center m-5 bg-bg1 flex-1 flex-col">
        <berry-no-data-found [avatarSize]="140" [label]="record.title | translate" [body]="record.message"></berry-no-data-found>
        <div class="btn-group-container">
            <berry-button [bottonType]="'button'" [data-automation-id]="'back-to-default-page'" [label]="'BackToMainPage_Common' | translate" (click)="goBack()"></berry-button>
            <berry-button [bottonType]="'button'" [data-automation-id]="'send-to-support-team'" [label]="'SendEmailToSupport_Common'| translate" (click)="senToSupportTeam()" [style]="'outline'"></berry-button>
        </div>
       
    </div>
  
</div>